// src/pages/NotificationsPage.jsx
import React from "react";
import {
  notificationSections as sections,
} from "../data/Notificaciones";
import { useNotifications } from "../components/Notificaciones/NotificationsContext";
import Notificacion from "../components/Notificaciones/Notificacion";

export default function NotificationsPage() {
  const { notifications, markAsRead } = useNotifications();

  const totalNotifications = notifications.length;

  return (
    <div className="w-full relative overflow-hidden px-8 py-6">
      <div className="flex items-center justify-between mb-10">
        <div>
          <p className="mt-4 text-[16px] font-medium text-[#0F0F0F]">
            You have {totalNotifications} notifications
          </p>
        </div>
      </div>

      <div className="space-y-10">
        {sections.map((section) => {
          const items = notifications.filter(
            (n) => n.section === section
          );

          if (items.length === 0) return null;

          return (
            <div key={section}>
              <h2 className="text-[16px] font-medium text-[#0F0F0F] mb-4">
                {section}
              </h2>

              <div className="max-w-[1210px]">
                {items.map((n) => (
                  <Notificacion
                    key={n.id}
                    titulo={n.title}
                    mensaje={n.description}
                    tiempo={n.timeLabel}
                    tipoAccion={!!n.cta}
                    isUnread={n.isUnread}
                    onClick={() => markAsRead(n.id)}  // 👈 marcar como leída
                    className="px-6 py-4"              // 👈 si quieres más padding aquí
                  />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
